import { useContext, useRef, useState } from "react";
import usePopup from "../../../hooks/usePopup";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  Tooltip,
  IconButton,
  CircularProgress,
  TableBody,
  Typography,
  Button,
} from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import { ContextType, LabContext } from ".";
import { useMutation } from "react-query";
import { getLabUploadedFiles } from "../services";
import useUploadLabFile from "../hook/useUploadLabFile";
import { CloudUpload } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import useViewFile from "../hook/useViewFile";
function UploadedFileList(params:{labId?:string | number}) {
  const { CustomModal, showSnackbar } = usePopup();
  const { encounterId } = useParams();
  const [open, setOpen] = useState(false);
  const { resultView,isResultSaved } = useContext(LabContext) as ContextType;
  const [selected, setSelected] = useState(-1);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const {
    mutate: getFileList,
    isLoading: fileListLoading,
    data: fileList,
  } = useMutation(getLabUploadedFiles, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        setOpen(true);
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 3000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message: e?.response?.data?.responseMessage || "Something went wrong !",
        open: true,
        variant: "error",
        duration: 3000,
      });
    },
  });

  const { mutate: getFile, isLoading: fileLoading } = useViewFile()
  const handleShowUploadedFiles = () => {
    getFileList(Number(resultView?.labId || params.labId));
  };
  const onSuccess = () => {
    fileInputRef.current!.value = "";
    handleShowUploadedFiles()
  };
  const onError = ()=>{
    fileInputRef.current!.value = ""
  }
  const { mutate: uploadFile, isLoading: fileUploadLoading } = useUploadLabFile(onSuccess,onError);
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      uploadFile({
        data: {
          _isEditMode: false,
          _isNew: false,
          _isUpdated: false,
          _isDeleted: false,
          _prevState: false,
          _defaultFieldName: "",
          _userId: 0,
          encounterId: Number(encounterId),
          groupId: 2,
          id: 0,
          labRequestId: resultView?.labId as number,
          isDashBoard:1,
          uploadFlag:0
        },
        file,
      });
    }
  };


  const handleShowFiles = (e: any) => {
    const index = Number(e?.currentTarget?.dataset?.index || "-1");
    const id = Number(e?.currentTarget?.dataset?.fileid || "-1");
    const filePath = String(e?.currentTarget?.dataset?.filepath || "-1");
    console.log("filePath = ",filePath)
    getFile({
       cptGrpId:2,
       id,
       isDashBoard:1,
       encounterId:Number(encounterId || "0"),
       requestId:Number(resultView?.labId || params?.labId || "0"),
       filePath
    });
    setSelected(index);
  };

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  console.log("encounterId => ",encounterId)

  return (
    <>
      <CustomModal open={open} setOpen={setOpen} title="Uploaded files">
        <div className="w-[50vw] max-h-[50dvh] overflow-y-auto">
          <div className="flex justify-end p-2">
          <input
            accept="application/pdf"
            type="file"
            style={{ display: "none" }}
            ref={fileInputRef}
            onChange={handleFileChange}
          />
         {isResultSaved && <Tooltip title="upload Results">
            <Button
             variant="text"
              onClick={handleButtonClick}
              disabled={fileUploadLoading || fileListLoading}
              endIcon={(fileUploadLoading || fileListLoading) ? (
                <CircularProgress size={20} />
              ) : (
                <CloudUpload color="primary" />
              )}
            >
              upload
            </Button>
          </Tooltip>}
          </div>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Sl No</TableCell>
                <TableCell>File name</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {fileList?.response?.map((file, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{file.fileName}</TableCell>
                  <TableCell>
                    <Button
                      disabled={fileLoading}
                      data-index={index}
                      data-fileid={file.resultId}
                      data-filepath={file.fileName}
                      onClick={handleShowFiles}
                      color="success"
                      endIcon={
                        index == selected && (fileLoading) ? (
                          <CircularProgress size={20} color="success" />
                        ) : (
                          <FileOpenIcon />
                        )
                      }
                    >
                      open
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
              <TableRow>
                {!Boolean(fileList?.response.length) && (
                  <TableCell align="center" colSpan={3}>
                    <Typography variant="h6">No files !</Typography>
                  </TableCell>
                )}
              </TableRow>
            </TableBody>
          </Table>
        </div>
      </CustomModal>
      <Tooltip title="Show uploaded files">
        <IconButton
          disabled={fileListLoading}
          onClick={handleShowUploadedFiles}
        >
          {fileListLoading ? (
            <CircularProgress size={18} color="secondary" />
          ) : (
            <DescriptionIcon color="secondary" />
          )}
        </IconButton>
      </Tooltip>
    </>
  );
}

export default UploadedFileList;
